import * as React from 'react'
import Label from '../components/label'
import { css } from '@emotion/react'
import { StaticImage } from 'gatsby-plugin-image'

const About = () => {
  return (
    <section css={sectionStyle}>
      <div css={sectionInnerStyle}>
        <Label labelTitle={'注意事項'} />
        <ul css={listStyle}>
          <li css={listBlockStyle}>
            <p css={listTextStyle}>
              会期中は24時間いつでもパソコン、スマートフォン、タブレットなどのデバイスで鑑賞できます。
            </p>
          </li>
          <li css={listBlockStyle}>
            <p css={listTextStyle}>バーチャルギャラリーには人数制限がございます、予めご了承ください。</p>
          </li>
          <li css={listBlockStyle}>
            <div css={listControlStyle}>
              <p css={listTextStyle}>・キーボードとマウスでの操作方法</p>
              <StaticImage src="../assets/images/control_device.png" alt="キーボードとマウスでの操作方法" />
            </div>
            <div css={listControlStyle}>
              <p css={listTextStyle}>・タッチスクリーンでの操作方法</p>
              <StaticImage src="../assets/images/control_touch.png" alt="タッチスクリーンでの操作方法" />
            </div>
          </li>
        </ul>
      </div>
    </section>
  )
}

const sectionStyle = css`
  width: 100%;
  margin-top: 120px;
  margin-bottom: 120px;
  @media (max-width: 768px) {
    margin-top: 44px;
    margin-bottom: 44px;
  }
`
const sectionInnerStyle = css`
  width: 1024px;
  margin: 0 auto;
  @media (max-width: 1023px) {
    width: 100%;
    padding: 0 24px;
  }
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 16px;
  }
`
const listStyle = css`
  display: flex;
  flex-direction: column;
  padding-top: 44px;
  @media (max-width: 768px) {
    padding-top: 24px;
  }
`
const listBlockStyle = css`
  display: flex;
  @media (max-width: 768px) {
    flex-direction: column;
  }
`
const listControlStyle = css`
  &:nth-of-type(1) {
    margin-right: 60px;
    width: 540px;
  }
  &:nth-of-type(2) {
    width: 424px;
  }
  @media (max-width: 768px) {
    &:nth-of-type(1) {
      margin-right: 0;
      width: 100%;
    }
    &:nth-of-type(2) {
      padding-top: 12px;
      width: 100%;
    }
  }
`
const listTextStyle = css`
  padding-bottom: 16px;
  font-size: 1.4rem;
  font-weight: 400;
  line-height: 1.5;
`

export default About
